var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4393 9.43934C15.9068 9.97187 15.8584 10.8052 16.2941 11.3924L16.4393 11.5607L29.378 24.5L16.4393 37.4393C15.9068 37.9719 15.8584 38.8052 16.2941 39.3924L16.4393 39.5607C16.9719 40.0932 17.8052 40.1416 18.3924 39.7059L18.5607 39.5607L32.5607 25.5607C33.0932 25.0281 33.1416 24.1948 32.7059 23.6076L32.5607 23.4393L18.5607 9.43934C17.9749 8.85355 17.0251 8.85355 16.4393 9.43934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0f75f13fc4e97dc89fa279078b522bc7.svg";
export { ForwardRef as ReactComponent };